import * as moment from 'moment';

const ENG_TO_HEB_MONTHS = {
  January: 'ינואר',
  February: 'פברואר',
  March: 'מרץ',
  April: 'אפריל',
  May: 'מאי',
  June: 'יוני',
  July: 'יולי',
  August: 'אוגוסט',
  September: 'ספטמבר',
  October: 'אוקטובר',
  November: 'נובמבר',
  December: 'דצמבר',
};

function getHebrewMonth(value) {
  return ENG_TO_HEB_MONTHS[moment(String(value)).format('MMMM')];
}

function getShortHebrewMonth(value) {
  return moment(String(value)).locale('he').format('MMM');
}

function normalizeDate(dateString) {
  return moment(dateString).format('D.M.YYYY');
}

function shortDateFormat(dateString) {
  return moment(dateString).format('D.M.YY');
}

function getDayInMonth(date) {
  return moment(date).format('DD');
}

function getYear(date) {
  return moment(date).format('YYYY');
}

function getMonthAndYear(date) {
  return moment(date).locale('he').format('MMMM YYYY');
}

function longHebrewDateFormat(date) {
  return `${getDayInMonth(date)} ל${getHebrewMonth(date)}, ${getYear(date)}`;
}

export default {
  getHebrewMonth,
  normalizeDate,
  shortDateFormat,
  getYear,
  getDayInMonth,
  longHebrewDateFormat,
  getShortHebrewMonth,
  getMonthAndYear,
};
